export const CARRIAGE_TYPE_PRE = 'pre'
export const CARRIAGE_TYPE_MAIN = 'main'
export const CARRIAGE_TYPE_ON = 'on'
export type TCarriagePlanType = typeof CARRIAGE_TYPE_PRE | typeof CARRIAGE_TYPE_MAIN | typeof CARRIAGE_TYPE_ON
